<template>
  <Modal
    class="tw-translate-y-[-50%] request-access-detail-modal"
    :max-width="DEFAULT_MAX_WIDTH_MODAL"
    :visible="showRef"
    :value="formModel"
    @close="handleCloseModal"
  >
    <ModalHeader
      class="modal-header"
      :title="
        getComponentUiText(
          action === actionClickType.actionProcessRequest
            ? 'app-settings-organisation-manage-access-approved-request-modal-title-1'
            : 'app-settings-organisation-manage-access-approved-offer-modal-title-1',
        )
      "
      :sub-title="currentOrg?.nameShort"
      @close="handleCloseModal"
    />

    <div class="tw-p-10 modal-request-access">
      <div class="tw-flex tw-items-center tw-gap-[15px]">
        <span
          class="tw-text-[25px] tw-text-[#211F58] tw-font-[600] tw-leading-none tw-capitalize"
          >{{
            getComponentUiText(
              action === actionClickType.actionProcessRequest
                ? "app-settings-organisation-manage-access-approved-request-modal-subtitle-1"
                : "app-settings-organisation-manage-access-approved-offer-modal-subtitle-1",
            )
          }}</span
        >
      </div>
      <BaseForm :show="showRef" :enter-event="true">
        <!-- Field : Requested by -->
        <BaseInput
          id="name"
          v-model="formModel.email"
          disabled
          :label="
            getComponentUiText(
              action === actionClickType.actionProcessRequest
                ? 'app-settings-organisation-manage-access-approved-request-modal-label-requested-by-1'
                : 'app-settings-organisation-manage-access-approved-request-modal-label-offer-by-1',
            )
          "
          :label-tooltip="
            getComponentUiText(
              action === actionClickType.actionProcessRequest
                ? 'app-settings-organisation-manage-access-approved-request-modal-hint-requested-by-1'
                : 'app-settings-organisation-manage-access-approved-request-modal-hint-offer-by-1',
            )
          "
        >
          <div
            class="tw-flex tw-gap-2 tw-items-center tw-w-full text-input-disable"
          >
            {{ formModel.email }}
          </div></BaseInput
        >
        <!-- Field : Org Relationship -->
        <BaseInput
          id="org-relationship"
          v-model="formModel.orgToOrgTypeId"
          :disabled="action !== actionClickType.actionProcessRequest"
          :validation="vueValidate.orgToOrgTypeId"
          :label="
            getComponentUiText(
              'app-settings-organisation-manage-access-modals-label-org-relationship-1',
            )
          "
          :label-tooltip="
            action === actionClickType.actionProcessRequest
              ? getComponentUiText(
                  'app-settings-organisation-manage-access-approved-request-modal-hint-organisational-relationship-1',
                )
              : ''
          "
        >
          <div
            v-if="action === actionClickType.actionProcessRequest"
            class="dropdown"
          >
            <BaseDropDown
              :id="'orgToOrgTypeId'"
              v-model="formModel.orgToOrgTypeId"
              :data="orgRelationshipOptions"
              :validation="vueValidate.orgToOrgTypeId"
              :class-name="'gray-dropdown-container tw-h-[58px]'"
              :placeholder="
                getComponentUiText(
                  'app-settings-organisation-manage-access-modals-prompt-org-relationship-1',
                )
              "
            />
          </div>
          <div
            v-else
            class="tw-flex tw-gap-2 tw-items-center tw-w-full text-input-disable"
          >
            {{ onGetOrgRelationshipLabel(formModel.orgToOrgTypeId) }}
          </div>
        </BaseInput>

        <!-- Field : Lock status -->
        <BaseInput
          id="lock-status"
          v-model="formModel.isLocked"
          :disabled="true"
          :validation="vueValidate.isLocked"
          :label="
            getComponentUiText(
              'app-settings-organisation-manage-access-modals-label-lock-status-1',
            )
          "
          :label-tooltip="
            getComponentUiText(
              action === actionClickType.actionProcessRequest
                ? 'app-settings-organisation-manage-access-approved-request-modal-hint-lock-status-1'
                : 'app-settings-organisation-manage-access-approved-offer-modal-hint-lock-status-1',
            )
          "
        >
          <div class="tw-flex tw-items-center tw-w-full text-input-disable">
            <img
              v-if="formModel.isLocked"
              class="tw-h-[14px] tw-w-[14px] tw-mr-[10px]"
              src="/img/lock1_icon.svg"
              alt="icon"
            />
            {{
              formModel.isLocked
                ? getComponentUiText(
                    "app-settings-organisation-manage-access-create-org-modal-locked-status-1",
                  )
                : getComponentUiText(
                    "app-settings-organisation-manage-access-create-org-modal-unlocked-status-1",
                  )
            }}
          </div>
        </BaseInput>

        <!-- Field : Role -->
        <BaseInput
          v-model="formModel.role"
          :validation="vueValidate.role"
          :validate-on-blur="true"
          :disabled="action !== actionClickType.actionProcessRequest"
          :placeholder="
            getComponentUiText(
              'app-settings-organisation-manage-access-approved-request-modal-placehoder-role-1',
            )
          "
          :label="
            getComponentUiText(
              'app-settings-organisation-manage-access-manage-offer-modal-form-label-role-1',
            )
          "
          :label-tooltip="
            action === actionClickType.actionProcessRequest
              ? getComponentUiText(
                  'app-settings-organisation-manage-access-approved-request-modal-hint-role-1',
                )
              : ''
          "
        >
          <div
            v-if="action === actionClickType.actionProcessRequest"
            class="dropdown"
          >
            <BaseDropDown
              :id="'permissionId'"
              v-model="formModel.role"
              :data="permissionLevelOptions"
              :validation="vueValidate.role"
              :class-name="'gray-dropdown-container tw-min-h-[58px] tw-text-[#FFFFFF]'"
              :placeholder="
                getComponentUiText(
                  'app-settings-organisation-manage-access-approved-request-modal-placehoder-role-1',
                )
              "
            />
          </div>
          <div
            v-else
            class="tw-flex tw-gap-2 tw-items-center tw-w-full text-input-disable"
          >
            {{ roleOfOffer }}
          </div>
        </BaseInput>
        <div
          class="button-container tw-flex tw-justify-end tw-mt-[40px] tw-gap-[10px]"
        >
          <b-button
            variant="primary"
            class="button-verify !tw-bg-[#fff] tw-py-[11px] tw-px-[18px] !tw-text-[#387DFF] tw-text-[15px] tw-font-medium tw-rounded-[27px] !tw-border-[2px]"
            @click="handleCloseModal"
          >
            {{ getComponentUiText("app-common-action-cancel-button-1") }}
          </b-button>
          <ButtonLoading
            :class="`button-verify !tw-bg-[#F7553C] !tw-border-[#F7553C] tw-text-[15px] tw-font-medium tw-rounded-[27px]`"
            :title="
              getComponentUiText(
                action === actionClickType.actionProcessRequest
                  ? 'app-settings-organisation-manage-access-actions-modal-reject-request-1'
                  : 'app-settings-organisation-manage-access-actions-modal-reject-offer-1',
              )
            "
            :is-loading="isCallApi && !isCallAccept"
            @click-action="onSubmit(false)"
          />
          <ButtonLoading
            :class="`button-verify  tw-text-[15px] tw-font-medium tw-rounded-[27px]`"
            :title="
              getComponentUiText(
                action === actionClickType.actionProcessRequest
                  ? 'app-settings-organisation-manage-access-actions-modal-accept-request-1'
                  : 'app-settings-organisation-manage-access-actions-modal-accept-offer-1',
              )
            "
            :is-loading="isCallApi && isCallAccept"
            @click-action="onSubmit(true)"
          />
        </div>
      </BaseForm>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { getComponentUiText } from "@/utils/utilities";
import {
  ref,
  onBeforeMount,
  Ref,
  computed,
  PropType,
  onMounted,
  nextTick,
} from "vue";

import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import BaseInput from "@/components/common/form/baseInput.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import {
  getOrgPermLevels,
  fetchOrgAccessType,
  getOrgRoles,
  orgAccessRequestProcess,
  orgAccessOfferProcess,
} from "@/services/org";
import BaseDropDown from "@/components/common/form/baseDropDown.vue";
import store from "@/store";
import BaseForm from "../common/form/baseForm.vue";
import get from "lodash/get";
import { actionClickType } from "@/utils/constants";

import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Invite, Org } from "@/services/apiRoutes/routes";
import ButtonLoading from "../common/buttonLoading.vue";
const DEFAULT_MAX_WIDTH_MODAL = 65;

const orgRelationshipOptions: Ref<IDropDownData[]> = ref([]);

const permissionLevelOptions: Ref<IDropDownData[]> = ref([]);

const props = defineProps({
  show: {
    type: Boolean,
    required: false,
  },
  action: {
    type: String,
    required: true,
    default: "",
  },
  requestDetail: {
    type: Object as PropType<any>,
    required: true,
  },
});
const currentOrg = computed(() => store.state.Org.currentOrg);

const emit = defineEmits(["update:show", "update:data"]);

const initialForm: any = {
  email: "",
  orgToOrgTypeId: null,
  isLocked: true,
  role: "",
};

const roleOfOffer = ref("");
const isCallApi = ref(false);

onMounted(() => {
  formModel.value.email = props.requestDetail?.requestedBy;
  formModel.value.orgToOrgTypeId = props.requestDetail?.orgRelationshipType;
  formModel.value.isLocked = props.requestDetail?.lockStatus;
  formModel.value.role = props.requestDetail?.role;
});

const onGetOrgRelationshipLabel = (id) => {
  const orgRelationship = orgRelationshipOptions.value.find(
    (relationship) => relationship.id === id,
  );
  return orgRelationship?.name;
};

const formModel: Ref<any> = ref({});

const rules =
  props.action === actionClickType.actionProcessRequest
    ? {
        orgToOrgTypeId: {
          required: helpers.withMessage(
            () => getComponentUiText("app-common-form-value-required-error-1"),
            required,
          ),
        },
        role: {
          required: helpers.withMessage(
            () => getComponentUiText("app-common-form-value-required-error-1"),
            required,
          ),
        },
      }
    : {};

const vueValidate = useVuelidate(rules, formModel);
let showRef = ref(props.show);

const clearData = () => {
  Object.assign(formModel, initialForm);
  vueValidate.value.$reset();
};

const handleCloseModal = () => {
  clearData();
  showRef.value = false;
  emit("update:show", showRef.value);
};

const isCallAccept = ref(false);

const onSubmit = async (isApproved) => {
  isCallAccept.value = isApproved;
  await vueValidate.value.$validate();
  if (vueValidate.value.$invalid) return;
  if (props.action === actionClickType.actionProcessRequest) {
    onProcessRequest(isApproved);
  } else {
    onProcessOffer(isApproved);
  }
};

const onProcessRequest = async (isApproved) => {
  try {
    isCallApi.value = true;
    const body = {
      id: props.requestDetail.id,
      isApproved: isApproved,
      roleId: `${formModel.value.role}`,
      orgToOrgTypeId: formModel.value.orgToOrgTypeId,
    };
    const formResponse = await orgAccessRequestProcess(body);

    if (formResponse.data?.message) {
      showSuccessToast(
        getComponentUiText(
          !isApproved
            ? "app-settings-organisation-manage-access-process-request-reject-modal-1"
            : "app-settings-organisation-manage-access-process-request-approved-modal-1",
          false,
          { orgName: currentOrg.value?.nameShort },
        ),
      );
      emit("update:data");
      handleCloseModal();
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Invite.orgAccessRequestProcess);
    }
  } finally {
    isCallApi.value = false;
  }
};

const onProcessOffer = async (isApproved) => {
  try {
    isCallApi.value = true;
    const res = await orgAccessOfferProcess({
      id: props.requestDetail.id,
      isAccepted: isApproved,
    });
    if (res.data?.message) {
      emit("update:data");
      showSuccessToast(
        getComponentUiText(
          isApproved
            ? "app-settings-organisation-manage-access-process-offer-approve-modal-1"
            : "app-settings-organisation-manage-access-process-offer-reject-modal-1",
          false,
          { orgName: currentOrg.value?.nameShort },
        ),
      );
    }
    handleCloseModal();
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Invite.orgAccessOfferProcess);
    }
  } finally {
    isCallApi.value = false;
  }
};

const fetchRoleMembersTypesData = async () => {
  try {
    const permissionLevelResponse = await getOrgPermLevels();
    const permissionLevelResponseData = get(
      permissionLevelResponse,
      "data.data",
      [],
    );

    const roleResponse = await getOrgRoles();
    let roleResponseData = get(roleResponse, "data.data", []);

    const currentPemissionLevel = permissionLevelResponseData.find(
      (permission) =>
        permission.permissionLevelId === props.requestDetail.permLevelId,
    );

    // append role options based on permission level
    roleResponseData = roleResponseData
      .map((role) => {
        const permissionLevel = permissionLevelResponseData.find(
          (permission) =>
            permission.permissionLevelId === role.permissionLevelId,
        );
        if (permissionLevel) {
          return {
            ...role,
            permissionLevelValue: permissionLevel.permissionLevelValue,
          };
        }
      })
      .sort((a, b) => a.permissionLevelValue - b.permissionLevelValue);

    const roleOptions = roleResponseData.filter((role) => {
      return (
        role.permissionLevelValue >= currentPemissionLevel.permissionLevelValue
      );
    });

    permissionLevelOptions.value = roleOptions.map((relationship) => ({
      name: relationship.roleName,
      id: relationship.roleId,
    }));
    formModel.value.role = permissionLevelOptions.value[0]?.id;
    roleOfOffer.value = permissionLevelOptions.value[0]?.name;
  } catch (error: any) {
    permissionLevelOptions.value = [];
    if (error && error.data) {
      showErrorAPI(error, Org.getOrgPermLevels);
    }
  }
};

const fetchOrgRelationship = async () => {
  try {
    const orgRelationshipResponse = await fetchOrgAccessType();
    if (orgRelationshipResponse?.data?.data) {
      orgRelationshipOptions.value = orgRelationshipResponse.data.data.map(
        (relationship) => ({
          name: relationship.name,
          id: relationship.id,
          isLockable: relationship.isLockable,
        }),
      );
    }
  } catch (error) {
    orgRelationshipOptions.value = [];
  }
};

const getFormData = async () => {
  fetchRoleMembersTypesData();
  fetchOrgRelationship();
};

onBeforeMount(() => {
  getFormData();
});
</script>

<style lang="scss">
.text-input-disable {
  border-radius: 6px;
  border: 1px solid var(--ui-rule, #eff0f1);
  background: var(--ui-rule-50, rgba(239, 240, 241, 0.5));
  padding: 18px 20px;
  height: 58px;
  color: #231f20;
  font-size: 13px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  &::placeholder {
    color: #b7b7b7;
  }
}
.request-access-detail-modal {
  .button-verify.btn.btn-primary[disabled] {
    background-color: #dbdbdb;
    color: #b7b7b7;
    border-color: #dbdbdb;
  }

  .copy-info-container {
    max-width: 70%;
  }

  .text-copy-container {
    width: calc(100% - 22px);
  }

  .button-delete {
    line-height: 100%;
    background-color: #f7553c;
    border-color: #f7553c;
  }

  .button-verify-later {
    line-height: 100%;
    border: 2px solid #387dff;
    background-color: #ffffff;
    color: #387dff;
  }

  .button-verify {
    line-height: 100%;
    background-color: #387dff;
    border-color: #387dff;
  }

  .status-domain {
    padding: 3px 5px;
    font-family: Poppins;
    font-size: 11px;
    font-weight: 500;
    line-height: 130%;
    border-radius: 4px;

    background: var(--ui-green-soft, #d9ede2);
    color: #01893d;
  }
}

@media (min-height: 768px) {
  .request-access-detail-modal {
    .modal-main {
      overflow: visible;

      .dropdown-menu {
        max-height: 169px;
        overflow: auto;
      }
    }
  }
}

@media (max-width: 991px) {
  .request-access-detail-modal {
    .copy-info-container {
      max-width: fit-content;
    }
  }
}

@media (max-width: 420px) {
  .request-access-detail-modal {
    .button-container-left {
      margin-top: 10px;
    }

    .field-container {
      flex-direction: column;
      align-items: flex-start;
    }

    .input-container {
      width: 100%;
      margin-top: 12px;
    }

    .label-container {
      width: unset !important;
    }
  }
}

@media (max-width: 575px) {
  .request-access-detail-modal {
    .label-container {
      margin-bottom: 4px;
    }
  }
}

@media (max-width: 768px) {
  .request-access-detail-modal {
    .row {
      margin-left: 0;
      margin-right: 0;
    }

    .col-sm-5 {
      padding-left: 0;
    }

    .col-sm-7 {
      padding-right: 0;
      padding-left: 0;
    }
  }
}

.input-base-form-input {
  border-radius: 6px;
  border: 1px solid var(--ui-rule, #eff0f1);
  background: var(--ui-rule-50, rgba(239, 240, 241, 0.5));
  padding: 18px 20px;
  height: 58px;
  color: #231f20;
  font-size: 13px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  &::placeholder {
    color: #b7b7b7;
  }
}

.invalid-feedback {
  font-size: 11px !important;
  font-family: Poppins !important;
  font-style: normal !important;
  font-weight: 500 !important;
  color: #f7553c !important;
  line-height: 130% !important;
  margin-top: 10px !important;
}
</style>
